/**
 * Created by lenovo on 2017/4/13.
 */
import xhr from './../xhr/'
import {ellaUrl} from 'CONFIG/path.config'

class BasicInfoService {

    updatePass({data}={}){
        return xhr({
            method : 'post',
            url : ellaUrl+"/user/updatePass",
            body:data
        })
    }
    //商户信息
    meList(id){
        return xhr({
            method : 'get',
            url : ellaUrl+'/user/me/'+id,
        })
    }
}

// 实例化后再导出
export default new BasicInfoService()


// WEBPACK FOOTER //
// ./modules/services/purifier/basicInfoService.js